export default __webpack_public_path__ + "static/wien-facd6135260fb1c9ca3e6f586c626b1b.svg";